import $ from 'jquery';
const MODAL_CLOSE_SELECTORS = ['#close', '#close-modal', '#close-popup']
const toggleModal = (e, $target)=>{
	if ($target.length!=1){
		return;
	}
	if (e){
		e.preventDefault();
		e.stopPropagation();
	}
	$target.toggleClass('is-modal-open');
	if ($('body .is-modal-open').length){
		$('body').addClass('has-modal-open');
	}
	else{
		$('body').removeClass('has-modal-open')
	}
}
$(document).on('click', '[data-wf-toggle="modal"]', function(e){
	const  target = $(this).data('target') || $(this).attr('href');
	toggleModal(e, $(target));
});
$(document).on('click', '.wp-block-bootstrap-modal', function(e){
	e.preventDefault();
	e.stopPropagation();
});

$(document).on('click', '.wp-block-button__link[href^="#"]', function(e){
	const $target = $($(this).attr('href'));
	if ($target.is('.wp-block-bootstrap-modal')){
	toggleModal(e, $target.parent());

	}
});

$(document).on('click', '.wp-block-bootstrap-modal__overlay', function(e){
	const  target = $(this);
	if ($(event.target).is('.wp-block-bootstrap-modal__overlay')){
		toggleModal(e, $(target));
	}
});

$(document).on('click', '.wp-block-bootstrap-modal [href]', function(e){
	const href = $(this).attr('href');
	if (!MODAL_CLOSE_SELECTORS.includes(href)){
		return;
	}
	const $target = $(this).closest('.wp-block-bootstrap-modal__overlay.is-modal-open');
	toggleModal(e, $target);
});

